import React, { useState } from "react"
import dayjs from "dayjs"
import { Link } from "react-router-dom"
import UseallOverview from "../Componentslogic/UseAlloverview"
import "../../Styles/MobileViewstyles.css" // Make sure to include/update your CSS file

const MobileDeliveryPage = () => {
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"))
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"))
  const [selectedFilter, setSelectedFilter] = useState("All")
  const [searchQuery, setSearchQuery] = useState("")
  const {
    data: deliveryData,
    loading,
    hasMore,
    nextPage,
  } = UseallOverview("DeliveryOrders", startDate, endDate)
  const getStatus = (order) => {
    if (order.delivered) return { text: "Delivered", className: "Delivered" }
    if (order.ontheWay) return { text: "On the Way", className: "fulfilled" }
    if (order.Donepreparing)
      return { text: "Done Preparing", className: "Done" }
    if (order.preparing) return { text: "Preparing", className: "unfulfilled" }
    return { text: "Placed", className: "pending" }
  }

  const filteredData = deliveryData.filter((order) => {
    const { text } = getStatus(order)
    const matchesSearch =
      !searchQuery || order.orderNumber.includes(searchQuery)
    const matchesFilter = selectedFilter === "All" || text === selectedFilter
    return matchesSearch && matchesFilter
  })

  const formatTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "N/A"
    const date = new Date(timestamp.seconds * 1000)
    return `${date.toLocaleDateString()} at ${date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`
  }

  return (
    <div className="mobile-dashboard-container">
      {/* Filters at the Top */}
      <div className="mobile-date-filters d-flex justify-content-around mt-4 mb-4">
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="start-date" className="mb-2">
            Start Date
          </label>
          <input
            id="start-date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="mobile-date-input"
          />
        </div>
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="end-date" className="mb-2">
            End Date
          </label>
          <input
            id="end-date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="mobile-date-input"
          />
        </div>
      </div>
      <div className="mobile-orders-container mt-4">
        {[
          "All",
          "Placed",
          "Preparing",
          "Done Preparing",
          "On the Way",
          "Delivered",
        ].map((filter) => (
          <div
            key={filter}
            className={`mobile-filter-card ${
              selectedFilter === filter ? "active" : ""
            }`}
            onClick={() => setSelectedFilter(filter)}
          >
            {filter === "All" ? "All Orders" : filter}
          </div>
        ))}
      </div>
      <div className="mobile-search-container mb-4">
        <input
          type="text"
          placeholder="Search by order number..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="mobile-search-input"
        />
      </div>

      {/* Orders as Cards in a Horizontal Scroll Container */}
      <div className="mobile-orders-container">
        {filteredData.map((order, index) => {
          const { text, className } = getStatus(order)
          return (
            <div key={index} className="mobile-order-card">
              <p>
                <strong>Order:</strong> {order.orderNumber}
              </p>
              <p>
                <strong>Date:</strong> {formatTimestamp(order.createdAt)}
              </p>
              <p>
                <strong>Customer:</strong> {order.userName}
              </p>
              <p>
                <strong>Total:</strong> {order.totalAmount} EGP
              </p>
              <p>
                <strong>Status:</strong>{" "}
                <span className={`status ${className}`}>{text}</span>
              </p>
              <p>
                <strong>Address:</strong> {order.address.street} -{" "}
                {order.address.buildingName}
              </p>
              <div className="d-flex justify-content-center mt-5">
                <Link to={`/adminDeliveryorderdetails/${order.id}`}>
                  <button className="mobile-view-btn">View</button>
                </Link>
              </div>
            </div>
          )
        })}
      </div>

      {/* Load More Button */}
      {hasMore && !loading && (
        <div className="mobile-load-more">
          <button onClick={() => nextPage()} className="mobile-load-more-btn">
            Load More
          </button>
        </div>
      )}
      {loading && <p>Loading...</p>}
    </div>
  )
}

export default MobileDeliveryPage
